<template>
  <div class="index-menu">
      <div class="el-header">LITCS</div>
      <div>
        <router-link to="case">
          <div class="links">
            LITCS
          </div>
        </router-link>
        <router-link to="quality" v-if="this.user.type === 2">
          <div class="links">
            质量保修
          </div>
        </router-link>
        <router-link to="quality-tmci" v-if="this.user.type === 1">
          <div class="links">
            质量保修
          </div>
        </router-link>
        <router-view></router-view>
      </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
      user: {}
    }
  },
  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
  }
}
</script>

<style scoped>
.index-menu{
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 99999;
}
.index-menu .el-header{
  background: #0366ca;
  line-height: 60px;
  margin-bottom: 10px;
}
.index-menu .links{
  width: 100%;
  margin: auto;
  height: 80px;
  line-height: 80px;
  background: #eee;
  margin-bottom: 10px;
}
</style>
